import './base/';
import './sliders/product-slider';
import './sliders/slider';
import './sliders/slider-images';
import './sliders/slider-block';
import './click-events/btn-toggle';
import './click-events/waypoint';
import './click-events/btn-video';
import './click-events/btn-popup-gallery';
import './click-events/btn-ajax';
import './click-events/navigation';
import './click-events/btn-login';
import './click-events/account-dashboard';
import './magnific-popups/newsletter-popup';
import './forms/addresses';
import './global/max-height';
import './grid/grid-isotope';
import './grid/grid-filter-isotope';
import './filter/filter';
import './cart/cart';
import './product/product';
